import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'
import type { SingleResponse } from '@/types/api'

/**
 * Modalidades do plano (Individual, Sênior, Familiar, Familiar+, Família).
 * Tabela backend: `plan_type_relationships` (mantida por compat com FK em `plans`).
 *
 * Cada modalidade declara:
 *  - idade mínima permitida
 *  - graus de parentesco aceitos (N:N)
 */
export interface ModalityDegreeRelationship {
  id: string
  degreeRelationship: string
  gender: string | null
}

export interface Modality {
  id: string
  name: string
  /** `null` = sem idade mínima */
  minAge: number | null
  status: 'ATIVO' | 'INATIVO'
  degreeRelationships?: ModalityDegreeRelationship[]
}

export interface ModalityPayload {
  name: string
  min_age: number | null
  status?: 'ATIVO' | 'INATIVO'
  degree_relationship_ids?: string[]
}

const base = createCrudService<Modality, ModalityPayload>(
  '/commercial/modalities',
  { searchField: 'name' },
)

export const ModalitiesService = {
  ...base,
  /** Lista simples para popular selects (sem paginação). */
  async listAll(): Promise<Modality[]> {
    const r = await api.get<{ data: Modality[] }>('/commercial/modalities', { params: { size: 100 } })
    return r.data.data
  },
  async setStatus(id: string, status: 'ATIVO' | 'INATIVO'): Promise<Modality> {
    const r = await api.put<SingleResponse<Modality>>(`/commercial/modalities/${id}/status`, { status })
    return r.data.data
  },
}
